export default {
  SPLUNK: 'splunk',
  SERVICE_NOW: 'servicenow',
  VENDOR: 'vendor'
};
